import * as tslib_1 from "tslib";
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { MutationCreateLocationGroupGQL, MutationUpdateLocationGroupGQL } from './api/mutations.service';
import { QueryLocationGroupGQL, QueryLocationsGroupsPaginatedGQL } from './api/queries.service';
import * as i0 from "@angular/core";
import * as i1 from "./api/queries.service";
import * as i2 from "./api/mutations.service";
import * as i3 from "../../../../@fuse/components/progress-bar/progress-bar.service";
var LocationsGroupsService = /** @class */ (function () {
    function LocationsGroupsService(locationsGroupsPaginatedGQL, locationGroupGQL, mutationCreateLocationGroupGQL, mutationUpdateLocationGroupGQL, fuseProgressBarService) {
        this.locationsGroupsPaginatedGQL = locationsGroupsPaginatedGQL;
        this.locationGroupGQL = locationGroupGQL;
        this.mutationCreateLocationGroupGQL = mutationCreateLocationGroupGQL;
        this.mutationUpdateLocationGroupGQL = mutationUpdateLocationGroupGQL;
        this.fuseProgressBarService = fuseProgressBarService;
    }
    LocationsGroupsService.prototype.getLocationsGroups = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                this.fuseProgressBarService.show();
                return [2 /*return*/, this.locationsGroupsPaginatedGQL.fetch({
                        where: where,
                        orderBy: options.orderBy,
                        limit: options.limit,
                        offset: options.offset
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        _this.fuseProgressBarService.hide();
                        return {
                            items: data.locationsGroups.items,
                            totalCount: data.locationsGroups.totalCount,
                            filtered: Boolean(!!where.name_contains || where.archived !== false)
                        };
                    })];
            });
        });
    };
    LocationsGroupsService.prototype.save = function (locationGroupId, locationGroup) {
        if (locationGroupId) {
            return this.update(locationGroupId, locationGroup);
        }
        return this.create(locationGroup);
    };
    LocationsGroupsService.prototype.create = function (locationGroup) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.fuseProgressBarService.show();
                return [2 /*return*/, this.mutationCreateLocationGroupGQL.mutate({
                        input: locationGroup
                    }).toPromise()];
            });
        });
    };
    LocationsGroupsService.prototype.update = function (locationGroupId, locationGroup) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.fuseProgressBarService.show();
                return [2 /*return*/, this.mutationUpdateLocationGroupGQL.mutate({
                        id: locationGroupId,
                        input: locationGroup
                    }).toPromise()];
            });
        });
    };
    LocationsGroupsService.prototype.getLocationGroup = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (id) {
                    this.fuseProgressBarService.show();
                    return [2 /*return*/, this.locationGroupGQL.fetch({ id: id })
                            .toPromise()
                            .then(function (_a) {
                            var data = _a.data;
                            _this.fuseProgressBarService.hide();
                            return data.locationGroup;
                        })];
                }
                return [2 /*return*/, null];
            });
        });
    };
    LocationsGroupsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocationsGroupsService_Factory() { return new LocationsGroupsService(i0.ɵɵinject(i1.QueryLocationsGroupsPaginatedGQL), i0.ɵɵinject(i1.QueryLocationGroupGQL), i0.ɵɵinject(i2.MutationCreateLocationGroupGQL), i0.ɵɵinject(i2.MutationUpdateLocationGroupGQL), i0.ɵɵinject(i3.FuseProgressBarService)); }, token: LocationsGroupsService, providedIn: "root" });
    return LocationsGroupsService;
}());
export { LocationsGroupsService };
